import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    // Language and Languages / Nga Reo
    { value: 'CHIN', label: 'Chinese (Mandarin)' },
    { value: 'COMM', label: 'Communication skills' },
    { value: 'COOK', label: "Te Reo Māori Kūki 'Āirani (Cook Islands Māori)" },
    { value: 'ENGL', label: 'English' },
    { value: 'ENSL', label: 'English as an additional language' },
    { value: 'FIJI', label: 'Fijian' },
    { value: 'FREN', label: 'French' },
    { value: 'GERM', label: 'German' },
    { value: 'INDO', label: 'Indonesian' },
    { value: 'JAPA', label: 'Japanese' },
    { value: 'KIRI', label: 'Kiribati' },
    { value: 'KORE', label: 'Korean' },
    { value: 'LATI', label: 'Latin' },
    { value: 'NAUR', label: 'Nauruan' },
    { value: 'NZSL', label: 'New Zealand Sign Language' },
    { value: 'NIUE', label: 'Vagahau Niue (Niuean)' },
    { value: 'OLAN', label: 'Other languages' },
    { value: 'PLAN', label: 'Pacific Language studies' },
    { value: 'PUKA', label: 'Pukapukan' },
    { value: 'ROTU', label: 'Rotuman' },
    { value: 'RUSS', label: 'Russian' },
    { value: 'SAMO', label: 'Gagana Sāmoa (Samoan)' },
    { value: 'SOLO', label: 'Solomon Islands' },
    { value: 'SPAN', label: 'Spanish' },
    { value: 'TAHI', label: 'Tahitian' },
    { value: 'MAOR', label: 'Te Reo Maori' },
    { value: 'RANG', label: 'Te Reo Rangatira' },
    { value: 'TOKE', label: 'Gagana Tokelau (Tokelauan)' },
    { value: 'TONG', label: 'Lea Faka-Tonga (Tongan)' },
    { value: 'TUVA', label: 'Tuvaluan' },
    { value: 'BISL', label: 'Vanuatu (Bislama)' },
    { value: 'VANU', label: 'Vanuatu' },

    // Mathematics / Pangarau
    { value: 'MATH', label: 'Mathematics' },
    { value: 'MATC', label: 'Mathematics with Calculus' },
    { value: 'MATS', label: 'Mathematics with Statistics' },
    { value: 'ACCO', label: 'Accounting' },

    // Science / Putaiao
    { value: 'SCIE', label: 'Science' },
    { value: 'AGHO', label: 'Agriculture/ Horticulture' },
    { value: 'BIOL', label: 'Biology/ Biological Science' },
    { value: 'CHEM', label: 'Chemistry' },
    { value: 'EAAS', label: 'Earth Science/Astronomy' },
    { value: 'HUMB', label: 'Human Biology' },
    { value: 'PHYS', label: 'Physics' },

    // Technology / Hangarau
    { value: 'TECN', label: 'Technology/Hangarau' },
    { value: 'BITE', label: 'Biotechnology' },
    { value: 'COSC', label: 'Computer science/programming' },
    { value: 'COMP', label: 'Computer studies' },
    { value: 'DEST', label: 'Design, Drawing and Graphics' },
    { value: 'DTEC', label: 'Digital Technologies' },
    { value: 'ELTE', label: 'Electronics and Control' },
    { value: 'FOTE', label: 'Food Technology' },
    { value: 'GRAP', label: 'Graphics' },
    { value: 'HOSP', label: 'Hospitality' },
    { value: 'INTE', label: 'Info. & Communication Tech' },
    { value: 'MTEC', label: 'Materials Technology' },
    { value: 'STME', label: 'Structures and Mechanisms' },
    { value: 'CLTX', label: 'Textiles/Clothing' },

    // The Arts / Nga Toi
    { value: 'ARTA', label: 'The Arts' },
    { value: 'ARTD', label: 'Art Design' },
    { value: 'ARTH', label: 'Art History' },
    { value: 'DANC', label: 'Dance' },
    { value: 'DRAM', label: 'Drama' },
    { value: 'MUSC', label: 'Music/Music Studies' },
    { value: 'MUSP', label: 'Music Practical/Performance' },
    { value: 'ARPA', label: 'Painting' },
    { value: 'APER', label: 'Performing Arts' },
    { value: 'ARTP', label: 'Photography' },
    { value: 'ARPR', label: 'Printmaking' },
    { value: 'ARTS', label: 'Sculpture' },
    { value: 'ARTC', label: 'Visual Arts' },

    // Social Sciences / Tikanga-a-iwi
    { value: 'SOST', label: 'Social Studies' },
    { value: 'CLST', label: 'Classics/Classical Studies' },
    { value: 'CMTY', label: 'Community Studies' },
    { value: 'CMRC', label: 'Commerce' },
    { value: 'ECON', label: 'Economics' },
    { value: 'SENV', label: 'Environment Studies, Sustainability' },
    { value: 'GEOG', label: 'Geography' },
    { value: 'HIST', label: 'History' },
    { value: 'LACU', label: 'Language & cultural studies' },
    { value: 'MAOS', label: 'Maori Studies' },
    { value: 'MEST', label: 'Media Studies' },
    { value: 'PAST', label: 'Pacific Studies' },
    { value: 'SOSC', label: 'Other Social Sciences' },
    { value: 'PSYC', label: 'Psychology' },

    // Health and Physical Education / Hauora
    { value: 'HEPH', label: 'Health and Physical Education' },
    { value: 'HEED', label: 'Health' },
    { value: 'HOME', label: 'Home Economics' },
    { value: 'OUED', label: 'Outdoor Education' },
    { value: 'PHED', label: 'Physical Education' },
    { value: 'SPOR', label: 'Sports Studies' },

    // Other
    { value: 'AGBU', label: 'Agribusiness' },
    { value: 'BUSS', label: 'Business Studies' },
    { value: 'DEFE', label: 'Defence' },
    { value: 'EQUE', label: 'Equestrian' },
    { value: 'FARM', label: 'Farming' },
    { value: 'FISH', label: 'Fishing' },
    { value: 'FOTY', label: 'Forestry' },
    { value: 'INTR', label: 'Industrial Trades' },
    { value: 'INTS', label: 'Integrated Studies' },
    { value: 'LAWS', label: 'Legal Studies' },
    { value: 'LIFE', label: 'Life skills/Personal development' },
    { value: 'REST', label: 'Religious Studies' },
    { value: 'REMS', label: 'Remedial Studies' },
    { value: 'STPR', label: 'Secondary Tertiary Programme' },
    { value: 'SETR', label: 'Service Trades' },
    { value: 'SPPR', label: 'Special Needs Programme' },
    { value: 'STDY', label: 'Study skills' },
    { value: 'TRAN', label: 'Transition/pre-employment' },
    { value: 'THTR', label: 'Travel and Tourism' },

    { value: 'NAPP', label: 'Non-applicable' },
  ],
});
